import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SaleMediaConversionLog } from 'src/app/models/sales/sale-media-conversion-log.model';

@Component({
  selector: 'app-sale-media-conversion-log-modal',
  templateUrl: './sale-media-conversion-log-modal.component.html',
  styleUrls: ['./sale-media-conversion-log-modal.component.scss'],
})
export class SaleMediaConversionLogModalComponent implements OnInit {
  @Input() public saleId!: number;
  @Input() public format!: string;
  @Input() public conversionLogs: SaleMediaConversionLog[] = [];
  @Input() public isLoader: boolean;
  public displayedColumns: string[] = ['studyFileId', 'createdDate', 'status'];

  constructor(public readonly modal: NgbActiveModal) {}

  closePopup(): void {
    this.modal.close();
  }

  ngOnInit(): void {}
}
